var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisitAbsences({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 4.375H5.25C4.76675 4.375 4.375 4.76675 4.375 5.25V22.75C4.375 23.2332 4.76675 23.625 5.25 23.625H22.75C23.2332 23.625 23.625 23.2332 23.625 22.75V5.25C23.625 4.76675 23.2332 4.375 22.75 4.375Z",
    stroke: "#3A6647",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 2.625V6.125",
    stroke: "#3A6647",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 2.625V6.125",
    stroke: "#3A6647",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 9.625H23.625",
    stroke: "#3A6647",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0625 14H13.125L11.375 16.1875C11.663 16.187 11.9467 16.2576 12.2009 16.393C12.455 16.5284 12.6719 16.7245 12.8321 16.9638C12.9924 17.2031 13.0911 17.4783 13.1195 17.7649C13.1479 18.0515 13.1051 18.3407 12.995 18.6068C12.8848 18.8729 12.7107 19.1077 12.488 19.2904C12.2654 19.4731 12.0011 19.598 11.7186 19.654C11.4361 19.7101 11.1441 19.6955 10.8686 19.6117C10.593 19.5279 10.3425 19.3773 10.1391 19.1734",
    stroke: "#3A6647",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 15.3125L17.5 14V19.6875",
    stroke: "#3A6647",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisitAbsences);
export default __webpack_public_path__ + "static/media/VisitAbsences.5bae3ca1515b5fbd1a2684abdc553ed5.svg";
export { ForwardRef as ReactComponent };